
import Swiper, {
    Controller as SwiperController,
    Navigation as SwiperNavigation,
} from 'swiper';

Swiper.use([SwiperController, SwiperNavigation]);
// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'ume-anchor-holder';
const slidableBreakpoint = '779px';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class umeAnchorHolder {
    constructor(el) {
        this.el = el;
        this._sliderActivated = false;

        this.$swiperWrapper = jQuery(el).find('.swiper-wrapper');
        this.$swiperContainer = jQuery(el).find('.swiper-container');
        this.$swiperPrev = jQuery(el).find('.swiper-button-prev');
        this.$swiperNext = jQuery(el).find('.swiper-button-next');
        this.$tabs = jQuery(el).find(`.swiper-slide`);

        this.$dropDownButton = jQuery(el).find(`.${baseClass}__button`);
        this.$link = jQuery(el).find(`.swiper-slide a`);

        this.mediaMatcher = window.matchMedia(`(max-width: ${slidableBreakpoint})`);

        if (!this.el.classList.contains('ume-anchor-holder--not-fixed')) {
            this.observer();
        }

        this.clickAnchor();

        if (el.classList.contains(`${baseClass}--personal`)) {
            this.anchorFromPersonal();
        }

        if (el.classList.contains(`${baseClass}--from-content`)) {
            this.anchorFromTextWithID();
        }

        if (this.el.classList.contains(`${baseClass}--slider`)) {
            this.initSlider();
        }

        if (this.mediaMatcher.matches) {
            this.toggleAnchor();

            if (this.el.classList.contains(`${baseClass}--slider`) || this.el.classList.contains(`${baseClass}--mobile-slider`)) {
                this.initSlider();
            }
        }

        this.mediaMatcher.addEventListener('change', (event) => {
            if (event.matches) {
                this.toggleAnchor();

                if (this.el.classList.contains(`${baseClass}--slider`) || this.el.classList.contains(`${baseClass}--mobile-slider`)) {
                    this.initSlider();
                }

            } else {
                this.$swiperWrapper.removeAttr('style');

                if (this.el.classList.contains(`${baseClass}--mobile-slider`) && !this.el.classList.contains(`${baseClass}--slider`)) {
                    this.destroySlider();
                }
            }
        });
    }

    anchorFromTextWithID() {
        for (let i=2; i<=6; i++) {
            let headers = document.querySelectorAll(`.ume-main h${i}`)
            for (let j=0; j<headers.length; j++) {
                if (headers[j].id !== '') {
                    if (!headers[j].closest('.modal')) {
                        const id = jQuery.trim(headers[j].id.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/gi, '').replaceAll(' ', '-'));
                        headers[j].setAttribute('id', id);
                        jQuery(`<li class="swiper-slide ume-starter-list-has-link"><a href="#${id}">${headers[j].innerText}</a></li>`).appendTo(`.${baseClass} .swiper-wrapper`);
                    }
                }
            }
        }
    }

    anchorFromPersonal() {
        const personalCategoryBlock = jQuery('.ume-mitarbeiter-wrapper__headline');

        for (const item of personalCategoryBlock) {
            let id = jQuery.trim(item.textContent.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').replaceAll(' ','-'));
            id = id.toLowerCase().replace(/\u00e4/g, "ae").replace(/\u00fc/g, "ue").replace(/\u00f6/g, "oe").replace(/\u00df/g, "ss");
            item.setAttribute('id', id);
            jQuery(`<li class="swiper-slide ume-starter-list-has-link"><a href="#${id}">${item.textContent}</a></li>`).appendTo(`.${baseClass} .swiper-wrapper`);
        }
    }

    observer() {
        if (
            "IntersectionObserver" in window &&
            "IntersectionObserverEntry" in window &&
            "intersectionRatio" in window.IntersectionObserverEntry.prototype
        ) {
            let observer = new IntersectionObserver(entries => {
                if (entries[0].boundingClientRect.y <= 0) {
                    document.querySelector(`.${baseClass}`).classList.add(`${baseClass}--fixed`);
                    this.checkAnchorHeight();
                } else {
                    document.querySelector(`.${baseClass}`).classList.remove(`${baseClass}--fixed`);

                    if (!this.mediaMatcher.matches) {
                        if (this.el.classList.contains(`${baseClass}--mobile-slider`) && !this.el.classList.contains(`${baseClass}--slider`)) {
                            this.destroySlider();
                        }
                    }
                }
            });
            observer.observe(document.querySelector(`.${baseClass}--anchor`));
        }
    }

    checkAnchorHeight() {
        const anchorHeight = this.el.scrollHeight;
        if (anchorHeight > 128) {
            this.initSlider();
        } else {

            if (this.mediaMatcher.matches) {
                if (this.el.classList.contains(`${baseClass}--mobile-slider`)) {
                    this.initSlider();
                }
            } else {
                if (this.el.classList.contains(`${baseClass}--slider`)) {
                    this.initSlider();
                }
            }
        }
    }

    toggleAnchor() {
        this.$dropDownButton.click(function (e) {
            e.preventDefault();
            const event = new Event('recalculateScrollPadding');
            if (jQuery(this).hasClass('is-open')) {
                jQuery(this).removeClass('is-open');
                jQuery(this).closest(jQuery(`.${baseClass}`)).find('.swiper-wrapper').slideUp();
                setTimeout(() =>{
                    document.dispatchEvent(event);
                }, 200)

            } else {
                jQuery(this).addClass('is-open');
                jQuery(this).closest(jQuery(`.${baseClass}`)).find('.swiper-wrapper').slideDown();
                setTimeout(() =>{
                    document.dispatchEvent(event);
                }, 200)
            }
        })
    }

    clickAnchor() {
        this.$link.click(function (e) {
            const currentLink = jQuery(this).attr('href');
            const linkDiv = document.querySelector(currentLink);
            const buttonClass = jQuery(`.${baseClass}__button`);

            if (buttonClass.hasClass('is-open')) {
                buttonClass.removeClass('is-open');
                buttonClass.closest(jQuery(`.${baseClass}`)).find('.swiper-wrapper').slideUp();
                const currentName = jQuery(this).text();

                if (currentName == '') {
                    return;
                }

                jQuery(this).closest(jQuery(`.${baseClass}`)).find(`.${baseClass}__button`).text(currentName);
            }

            if (linkDiv == null) {
                return;
            }

            if (linkDiv.parentNode.classList.contains('card-accordion')) {
                if (currentLink.startsWith('#')) {

                    if (linkDiv.classList.contains('show')) {
                        return;
                    }

                    e.preventDefault();
                    linkDiv.parentNode.querySelector(`[data-target="${currentLink}"]`).click();

                    const transition = document.querySelector(currentLink);

                    transition.ontransitionend = () => {
                        const headerHeight = document.querySelector('header').offsetHeight;
                        let anchorBlockHeight = document.querySelector(`.${baseClass}`).offsetHeight;

                        if (window.innerWidth < 780) {
                            if (!document.querySelector(`.${baseClass}`).classList.contains('ume-anchor-holder--fixed')) {
                                anchorBlockHeight = document.querySelector(`.${baseClass}`).offsetHeight * 2;
                            }
                        }

                        const elementPosition = linkDiv.getBoundingClientRect().top;
                        const offsetPosition = elementPosition + window.scrollY - (headerHeight + anchorBlockHeight + (headerHeight / 2));

                        window.scrollTo({
                            top: offsetPosition,
                            behavior: "smooth"
                        });
                    };
                }
            }
        });
    }

    initSlider() {
        if (this.$tabs.length === 1 ) {
            return;
        }

        this.swiper = new Swiper(this.$swiperContainer[0], {
            slidesPerView: "auto",
            centeredSlides: false,

            navigation: {
                nextEl: this.$swiperNext[0],
                prevEl: this.$swiperPrev[0],
            },

            observer: true,
            observeParents: true,
            observeSlideChildren: true
        });

        this._sliderActivated = true;
    }

    destroySlider() {
        if (this._sliderActivated === false || this.$tabs.length === 1) {
            return;
        }

        this.swiper.destroy();
        this.swiper = null;

        this._sliderActivated = false;
    }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
    jQuery(`.${baseClass}`).each((i, el) => new umeAnchorHolder(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------


jQuery(document).ready(() => {
    init();
});